import {Component, OnChanges, Output, EventEmitter, Input} from '@angular/core';

import { CDSNode, Package } from '../services/capd.model';
import { OrgService } from '../services/org.service';

@Component({
  selector: 'company-assign-package',
  templateUrl: './company-assign-package.component.html',
  inputs: ['org']
})

/**
 * This class defines the modal used to assign packages to a company.
 */
export class CompanyAssignPackageComponent implements OnChanges {
  @Output() update: EventEmitter<any> = new EventEmitter<any>();
  @Input() org: CDSNode;
  packList: Package[];
  toAdd: {contentPackage_id: string};

  constructor(private _service: OrgService) { }

/**
 * On changes, refresh the list of unassigned org packages.
 *
 * @async
 * @func ngOnChanges
 */
  ngOnChanges() {
    this._service.getUnassignedOrgPackages(this.org.rootId)
      .then((packs: Package[]) => this.packList = packs);
  }

/**
 * Change the currently selected package
 *
 * @func updateChecked
 * @param {any} option - a content package ID to add to the org.
 */
  updateChecked(option) {
      this.toAdd = option;
  }

/**
 * Confirms the assignment of a package to an org, and updates the tables accordingly.
 *
 * @async
 * @func onSubmit
 */
  onSubmit() {
    this._service.pullPackageToOrg(this.toAdd, this.org.rootId).then(() => {
      const emit = this.toAdd;
      this.toAdd = null;
      this.update.emit(emit);
    });
  }

/**
 * When you cancel to dismiss the modal, clear the current package to add.
 *
 * @func onCancel
 */
  onCancel() {
    this.toAdd = null;
  }
}
